import Logo from "@/assets/logo.svg";

import "./styles.scss";
import { Button } from "../button";
import { IMobileMenuProps } from "./types";
import { useTracking } from "@/hooks/useTracking";

export const MobileMenu = ({ onClose }: IMobileMenuProps) => {
  const { sendEvent } = useTracking();

  const handleClickItem = (item: string) => {
    onClose?.();

    sendEvent("button_clicked", {
      event_category: "mobile_menu",
      event_label: item,
      event_action: "mobile_header_item_clicked",
      value: 1,
    });
  };

  return (
    <div className="mobile-menu">
      <div className="mobile-menu__header">
        <img
          src={Logo}
          alt="Logo da Provenduz"
          className="mobile-menu__header--logo"
        />
        <i
          className="bx bx-x mobile-menu__header--close-button"
          onClick={() => handleClickItem("logo")}
        ></i>
      </div>

      <nav className="mobile-menu__content">
        <ul>
          <li className="header__menu--item">
            <a href="/#" onClick={() => handleClickItem("home")}>Início</a>
          </li>
          <li className="header__menu--item">
            <a href="/#plans" onClick={() => handleClickItem("plans")}>Planos</a>
          </li>
          <li className="header__menu--item">
            <a href="https://linktr.ee/provenduz" target="_blank" onClick={() => handleClickItem("contact")}>
              Contato
            </a>
          </li>
        </ul>
      </nav>

      {import.meta.env.URL_PORTAL && (
        <div className="mobile-menu__footer">
          <Button
            theme="primary"
            size="small"
            className="mobile-menu__footer--button"
            onClick={() => {
              handleClickItem("login")

              const URL = import.meta.env.URL_PORTAL
              if (URL)
                window.open(URL, "_blank")
            }}
          >
            Entrar
          </Button>
        </div>
      )}
    </div>
  );
};
